export const getUiCheckboxFieldTemplate = (options) => {
  const {
    theme = 'main',
    size = 'small',
    sizeMode = '',
    fieldAttrs = '',
    fieldText = '',
    fieldName = '',
    classes = '',
    isVisualDisabled = false
  } = options

  return `
    <label class="
        ui-checkbox-field
        f
        ui-checkbox-field--${theme}
        ui-checkbox-field--${size}
        ${sizeMode ? `ui-checkbox-field--${sizeMode}` : ''}
        ${classes}
      "
    >
      <input
        class="
          ui-checkbox-field__input sr-only
          ${isVisualDisabled ? 'ui-checkbox-field__input--v-disabled' : ''}
        "
        name="${fieldName}"
        type="checkbox"
        ${fieldAttrs}
      >
      <span
        class="
          ui-checkbox-field__value
          ${!fieldText ? 'ui-checkbox-field__input--single' : ''}
        "
      >
        <svg
          class="
            ui-checkbox-field__icon
          "
          width="16"
          height="12"
          aria-hidden="true"
        >
          <use href="#ui-done"></use>
        </svg>

        ${fieldText}
      </span>
    </label>
  `
}
